export default __webpack_public_path__ + "static/media/waiting.4afb004a.png";